import Swagger from 'swagger-client';

import allStores from "../stores/StoreLoader";
import {ExecutionEnvironment, isServerComponent} from "../stores/InterfaceStore";
import {getConfig} from "../_configs/AppConfig";
import {getCookieFromString} from "../utils/StringUtilities";

const {publicRuntimeConfig} = getConfig();

function createSingleton(swaggerAuthorization): Swagger {
    const swag = {
        url: publicRuntimeConfig.API_SPEC_URL,
        usePromise: true,
        debug: false,
        requestInterceptor: req => {
            if (req.url === publicRuntimeConfig.API_SPEC_URL) {
                // default Accept value in swagger-client 3.x is "application/json, "application/yaml", but Watson uses "application/openapi+json"
                req.headers["Accept"] = ["application/openapi+json"];
            } else {
                // TODO remove after SBSB-2043 is fully released
                req.headers["Accept"] = ["*/*; accept-html=true"];
            }
        },
    }
    if (swaggerAuthorization) {
        // @ts-ignore
        swag.authorizations = {
            WatsonAuthentication: swaggerAuthorization,
        }
    }
    return new Swagger(swag);
}

let swaggerSingleton: Swagger | null = null;

export default async function WatsonApi(token: string | null = null) {
    if (ExecutionEnvironment.canUseDOM) {
        token = getCookieFromString("token", document.cookie);
    } else if (isServerComponent) {
        const {cookies} = await import("next/headers");
        const c = await cookies();
        token = (c.get("token") as string | undefined) || null;
    }

    // always create a new singleton for server-side calls, or credentials will be shared across clients!
    if (!swaggerSingleton || !ExecutionEnvironment.canUseDOM) {
        swaggerSingleton = createSingleton(token);
    }

    const client = await swaggerSingleton;

    if (!client.authorizations) {
        client.authorizations = {}
    }
    if (token) {
        client.authorizations["WatsonAuthentication"] = token
    }
    client.authorizations["accept-language"] = allStores.i18nStore.currentOrgSupportedLocale
    client.authorizations["AppContext"] = process.env.NEXT_PUBLIC_APP_CTX

    return client;
}
